import { createRouter, createWebHistory } from 'vue-router'
import Home from '@/views/Home';
// const Aktuelles = () => import('@/views/Aktuelles');
const Leitfaden = () => import('@/views/Leitfaden');
const Team = () => import('@/views/Team');
const Tagesablauf = () => import('@/views/Tagesablauf');
const Anmeldung = () => import('@/views/Anmeldung');
const Verein = () => import('@/views/Verein');
const Impressum = () => import('@/views/Impressum');
const Datenschutz = () => import('@/views/Datenschutz');
const PageNotFound = () => import('@/views/PageNotFound');

const routerHistory = createWebHistory()

const router = createRouter({
  history: routerHistory,
  routes: [
    { 
      path: '/', 
      name: 'Startseite',
      component: Home,
    },
    // { 
    //   path: '/aktuelles', 
    //   name: 'Aktuelles',
    //   component: Aktuelles,
    // },
    { 
      path: '/leitfaden', 
      name: 'Leitfaden',
      component: Leitfaden,
    },
    { 
      path: '/team', 
      name: 'Team',
      component: Team,
    },
    { 
      path: '/tagesablauf', 
      name: 'Tagesablauf',
      component: Tagesablauf,
    },
    { 
      path: '/anmeldung', 
      name: 'Anmeldung',
      component: Anmeldung,
    },
    { 
      path: '/verein', 
      name: 'Verein',
      component: Verein,
    },
    { 
      path: '/impressum', 
      name: 'Impressum',
      component: Impressum,
    },
    { 
      path: '/datenschutz', 
      name: 'Datenschutz',
      component: Datenschutz,
    },
    { 
      path: '/:pathMatch(.*)*',
      name: '404',
      component: PageNotFound 
    }
  ],  
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { x: 0, y: 0 }
  },
})

export { router }